import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDropzone } from "react-dropzone";
import { useAcceptedFile } from "@/utils/utils.js";
import ModalWrapperChildren from '@/views/components/Modal/ModalWrapperChildren';
import SimpleAlert from '@/views/components/Alert/Alert';

import api from "@/services/api";

const ModalUploadUsers = ({reloadList, showModalUpload, setShowModalUpload}) => {
	const { dict, usersLimit } = useSelector(state => state.app);
	const [ requestIsPending, setRequestIsPending ] = useState(false);
	const [ error, setError ] = useState(null);
	const [ myFiles, setMyFiles ] = useState([]);
	const [ showAlert, setShowAlert ] = useState(false);
	
	const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
		accept: {
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [ ".xlsx" ],
		},
		multiple: false,
	});

	const getErrorText = (type, rows) => {
		if (type === 'header') {
			return (
				<>
					<div className="modal__load-dictionary--error-header">
						<span className="modal__load-dictionary--error-message-header">{dict.users.modalLoad.errors.header}</span>
						&nbsp;
						<span>{dict.users.modalLoad.errors.check}</span>
					</div>
					<ol className="modal__load-dictionary--error-messageList">
						<li>{dict.users.modalLoad.errors.format}</li>
						<li>{dict.users.modalLoad.errors.rows}</li>
					</ol>
				</>
			);
		} else if(type === 'rows') {
			return (
				<>
					<div className="modal__load-dictionary--error-header">
						<span className="modal__load-dictionary--error-message-header">{dict.users.modalLoad.errors.header}</span>
						&nbsp;
						<span>{dict.users.modalLoad.errors.inRegardsTo} {rows.join(', ')}.</span>
						&nbsp;
						<span>{dict.users.modalLoad.errors.check}</span>
					</div>
					<ol className="modal__load-dictionary--error-messageList">
						<li>{dict.users.modalLoad.errors.mandatory}</li>
						<li>{dict.users.modalLoad.errors.dataFormat}</li>
						{usersLimit && (usersLimit.admins || usersLimit.experts || usersLimit.editors || usersLimit.readers) && <li>{dict.users.modalLoad.errors.limit}</li>}
					</ol>
				</>
			);
		}

		return (
			<>
				<div className="modal__load-dictionary--error-header">
					<span className="modal__load-dictionary--error-message-header">{dict.users.modalLoad.errors.header}</span>
					&nbsp;
					<span>{dict.users.modalLoad.errors.check}</span>
				</div>
				<ol className="modal__load-dictionary--error-messageList">
					<li>{dict.users.modalLoad.errors.format}</li>
					<li>{dict.users.modalLoad.errors.rows}</li>
				</ol>
			</>
		);
	};

	//const getErrorFile = useErrorFile();
	const getAcceptedFile = useAcceptedFile();

	const handleClose = () => {
		setShowModalUpload(false); 
		reloadList();
		setError(null);
		setMyFiles([]);
		setShowAlert(false);
		setRequestIsPending(false);
	};

	const addFile = () => {
		if (acceptedFiles.length > 0) {
			setRequestIsPending(true);
			const formData = new FormData();
			formData.append("usersFile", acceptedFiles[0]);
	
			api.post(`/users/import/excel`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			}).then(res => {
				if(res.status === 200) {
					if(res.data.length > 0) {
						getErrorRows(res.data);
					} else if (res.data.length === 0 ) {
						setShowModalUpload(false);
						reloadList();
					}
				}
				setRequestIsPending(false);
			});
		}
	};
	
	const getErrorRows = (errorRow) => {
		if(errorRow.length === 1 && errorRow[0] === 1) {
			setError(getErrorText('header', errorRow));
		} else if (errorRow.length > 0) {
			//const rows = errorRow.map(row => row).join(', ');
			setError(getErrorText('rows', errorRow));
		}
	};

	useEffect(() => {
		if(fileRejections.length > 0) {
			//const err = fileRejections.map(f => f.errors.map(e => getErrorFile(e.code)));
			setError(getErrorText());
		} else {
			setError('');	
		}
	}, [ fileRejections ]);

	useEffect(() => {
		if(acceptedFiles.length > 0) {
			setMyFiles(getAcceptedFile(acceptedFiles));
			if (myFiles != []) {
				setShowAlert(true);
			}
		}
	}, [ acceptedFiles ]);

	return (		
		<ModalWrapperChildren 
			onClose={ () => handleClose() }
			setModalVisible={ setShowModalUpload }
			modalVisible={ showModalUpload }
			onConfirm={ () => addFile() }
			closeButtonName={ dict.cancel }
			confirmButtonName={ dict.load }
			disabled={ !acceptedFiles || acceptedFiles.length < 1 }
			requestIsPending={ requestIsPending }
			title={ dict.users.modalLoad.title }
			description={ <><span> {dict.users.modalLoad.loadFileWithList}</span>
				<ol className="modal-children__desc-list">
					<li> {dict.users.modalLoad.name} </li>
					<li> {dict.users.modalLoad.surname} </li>
					<li> {dict.users.modalLoad.email} </li>
					<li> {dict.users.modalLoad.department} </li>
					<li> {dict.users.modalLoad.role} </li>
				</ol>
				{usersLimit && (usersLimit.admins || usersLimit.experts || usersLimit.editors || usersLimit.readers) && <SimpleAlert variant="warning"
					className = "modal__load-dictionary--warning"
					alertContent = { <> 
						<span className="modal__load-dictionary--error-message-header">{ dict.users.modalLoad.limitWarning.part1 }</span>
						{ dict.users.modalLoad.limitWarning.part2 } 
						{ usersLimit.admins } 
						{ usersLimit.admins === 1 ? dict.users.modalLoad.limitWarning.part3Singular : dict.users.modalLoad.limitWarning.part3 } 
						{ usersLimit.experts } 
						{ usersLimit.experts === 1 ? dict.users.modalLoad.limitWarning.part4Singular : dict.users.modalLoad.limitWarning.part4 } 
						{ usersLimit.editors } 
						{ usersLimit.editors === 1 ? dict.users.modalLoad.limitWarning.part5Singular : dict.users.modalLoad.limitWarning.part5 } 
						{ usersLimit.readers } 
						{ usersLimit.readers === 1 ? dict.users.modalLoad.limitWarning.part6Singular : dict.users.modalLoad.limitWarning.part6 }
					</> } /> }
				<div style={ { marginTop: '12px' } }>{dict.users.modalLoad.desc}</div>
			</> }
			isLine
		>		
			<div className="modal__load-dictionary--descAddingUser">
				<p 
					className="modal-children__desc" 
					style={ { marginBottom: '5px' } }
				>{dict.users.modalLoad.info}</p>
				<section className="modal__load-dictionary--dropzone">
					{error && <SimpleAlert variant='error'
						className = 'modal__load-dictionary--error'
						alertContent = { error } />}
					{showAlert && <><SimpleAlert variant="info"
						className = "modal__load-dictionary--loadInfo"
						alertContent = { <><span className="modal__load-dictionary--mergedDict"> { myFiles } </span> </> } />
					<p 
						className="modal-children__desc" 
						style={ { marginBottom: '5px' } }
					> { dict.users.modalLoad.anotherFile } </p></>}
					<div 
						{ ...getRootProps({ className: "addletter__dropzone" }) }
					>
						<input { ...getInputProps() } />
						<p><span>{dict.users.modalLoad.browse}</span> {dict.users.modalLoad.dragFiles}</p>
					</div>
					<div className="modal-children__info2-container">
						<i className='icon-circle-info'/>
						<p className="modal-children__info2">{dict.users.modalLoad.warningMessage.part1}<strong>{dict.users.modalLoad.warningMessage.part2}</strong>{dict.users.modalLoad.warningMessage.part3}</p>
					</div>
				</section>
			</div>
		</ModalWrapperChildren>
	);
};

export default ModalUploadUsers;
